import { Store } from 'libx'
import { task } from 'mobx-task'
import { observable, action } from 'mobx'
import { validationContext, required, pattern, func } from 'validx'
import { extractMessageFromError } from 'utils/errorUtil'

export default class RequestMagicLinkStore extends Store {
  @observable
  email = ''

  @observable
  magicLinkRequested = false

  validation = validationContext(this, {
    email: [
      required('Email is required'),
      pattern({ pattern: 'email', msg: 'Not a valid email' }),
      func(({ value }) => {
        return value.length <= 320 || "Email can't be more than 320 characters"
      }),
    ],
  })

  @action
  setMagicLinkRequested(value) {
    this.magicLinkRequested = value
  }

  @action
  tryAgain() {
    this.setMagicLinkRequested(false)
  }

  @task.resolved
  requestMagicLink(workspaceId, email) {
    if (!this.validation.reset().validate().isValid) {
      return
    }

    return this.rootStore.magicLinkStore
      .request(workspaceId, email)
      .then(() => this.setMagicLinkRequested(true))
      .catch((err) => {
        const message =
          err.response?.status === 429
            ? 'You have made too many requests. Please try again in a few minutes.'
            : extractMessageFromError(err)

        this.rootStore.flashMessageStore
          .create({
            message: message,
            type: 'error',
          })
          .autoDismiss()

        throw err
      })
  }
}
